import type {
  ContextTokensRequestDTO,
  ContextTokensResponseDTO,
} from "@/application/records/dtos/ContextTokensDTO";
import type { RecordsGatewayPort } from "@/application/records/ports/RecordsGatewayPort";

/**
 * Use case: fetch aggregated context tokens for the given records.
 */
export class FetchContextTokensUseCase {
  constructor(private readonly gateway: RecordsGatewayPort) {}

  async execute(
    request: ContextTokensRequestDTO
  ): Promise<ContextTokensResponseDTO> {
    if (!request.recordIds || request.recordIds.length === 0) {
      return { totalTokens: 0, ratePer100k: 0 };
    }

    return this.gateway.getContextTokens(request);
  }
}
